import { SiiEmploymentTypeEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function siiEmploymentTypeNameFilter(type: SiiEmploymentTypeEnum): string {
  switch (type) {
    case SiiEmploymentTypeEnum.OneEighth:
      return i18n.t(LF.OneEighthTimeJob) as string;
    case SiiEmploymentTypeEnum.FullTime:
      return i18n.t(LF.FullTimeJob) as string;
    case SiiEmploymentTypeEnum.HalfTime:
      return i18n.t(LF.HalfTimeJob) as string;
    case SiiEmploymentTypeEnum.QuarterTime:
      return i18n.t(LF.QuarterTimeJob) as string;
    default:
      return '';
  }
}
